import { FONT_FAMILY_REGULAR } from 'src/styles/fonts/MCFontConstants';

export const titleMarginLeftStyle = {
    marginLeft: '10px',
};

export const titlePaddingRightStyle = {
    paddingRight: '10px',
};

export const spanBaseStyle = {
    fontFamily: FONT_FAMILY_REGULAR,
    textTransform: 'lowercase',
    marginLeft: '10px',
};

export const spanLineThroughStyle = {
    ...spanBaseStyle,
    textDecoration: 'line-through',
    color: '#f70446',
};

export const spanRedStyle = {
    ...spanBaseStyle,
    color: '#f70446',
};
